import CDNImage from './CDNImage.jsx'
import UploadImage from './UploadImage.jsx'

export { CDNImage, UploadImage }



// WEBPACK FOOTER //
// ./components/UI/Image/index.js